import PropTypes from 'prop-types';
import React from 'react';

export default (React.PropTypes = PropTypes);


// WEBPACK FOOTER //
// ./src/react_data_grid_hacks/fix-prop-types.js